import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const CustomizeGiftCard = lazyWithPreload(
  () => import('./CustomizeGiftCard'),
)
